// ————————————————————————————————————————————— DOC. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const logArgs = { eventName: "api.get_preloadManifest", inline: true };
const loggerMsgs = {
  eventStart: ["Preloader", "API", "get_preloadManifest"],
  noManifest: ["Preloader", "API", "get_preloadManifest", "no manifest found"],
  fetchError: (ROUTE, ERROR) => [`an error occurred while fetching preload manifest for route ${ROUTE}`, ERROR],
};

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default async function get_preloadManifest(ROUTE) {
  // Setup...
  this.logger("event", loggerMsgs.eventStart, "event", logArgs);

  // Attempt to fetch preload manifest...
  try {
    const routeDataRequest = await fetch(`/${ROUTE}.json`);

    // Stop, if no manifest found...
    if (routeDataRequest.status === 404) {
      this.logger("error", loggerMsgs.noManifest, "error", logArgs);
      return false;
    }

    const routeData = await routeDataRequest.json();
    return routeData.manifest;
  } catch (error) {
    this.logger("error", loggerMsgs.fetchError(ROUTE, error), "error", { ...logArgs, inline: false });
    return null;
  }
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
